import { Stack } from '@mui/material';
import { authUtil } from 'modules';
import { StyledInputTextField } from 'modules/components';
import { BaseDialogLayout } from 'modules/components/layer02';
import * as ds from './dataService';


export type ForgotPasswordModalProps = {
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ForgotPasswordModalProps) => {
  const { form } = ds.useQuery();

  const { formState, genFieldProps, dispatch } = form;

  const handleSubmit = (userForm: typeof formState) => {
    if (userForm.emailSent === false) {
      authUtil.resetPassword(userForm.email);

      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'emailSent',
          value: true
        }
      });

    } else if (userForm.emailSent === true) {
      authUtil.confirmResetPassword({
        email: userForm.email,
        password: userForm.password,
        confirmationCode: userForm.code.trim()
      });
      props.handleClose();
    }
  };

  return (
    <BaseDialogLayout.FC
      formTitle='Forgot Password'
      isVisible={props.isVisible}
      handleClose={props.handleClose}
      handleSubmit={() => handleSubmit(formState)}
      saveText='Reset Password'
      subTitle=''
      titleIcon={<></>}
    >
      {
        !formState.emailSent
          ? (
            <StyledInputTextField.FC
              {...genFieldProps('email')}
            />
          )
          : (
            <Stack
              rowGap='.5rem'
            >
              <StyledInputTextField.FC
                {...genFieldProps('code')}
              />
              <StyledInputTextField.FC
                {...genFieldProps('password')}
              />
              <StyledInputTextField.FC
                {...genFieldProps('confirmPassword')}
              />
            </Stack>
          )
      }


    </BaseDialogLayout.FC>
  );
};
